// Типы для структуры
export const structureEndpoints = {
    recalculateStructure: {
        query: () => ({
            url: "/admin/structure/recalculate",
            method: "POST",
        }),
    },
};

export const structureTags = ["Structure"] as const;
